<span id="{{'similarity-row-' + row.id}}"
      [stickyPopover]="popContent"
      [popoverTitle]="popTitle"
      [autoClose]="false"
      [animation]="false"
      [placement]="['right-bottom','right-top', 'right']"
      [openDelay]="300"
      popoverClass='similarity-popover'
      style="font-size: 15px"
      container="body"
      triggers="manual">
    <i class="fa-light fa-tilde"></i>
</span>

<ng-template #popTitle>
  <i class="fa-light fa-tilde me-1"></i>Text-based similarity for {{row.sourceName || row.code || row.bibCode}}
</ng-template>

<ng-template #popContent>
  <ng-container *ngIf="row?.datasetId">
    <ng-container *ngIf="!isLoading; else loading">
      <ng-container>
        <asax-result-table-cell-similarity-text
          [similarProjects]="similarProjects"
          [similarPublications]="similarPublications"
          [tabId]="tabId"
        ></asax-result-table-cell-similarity-text>
        <asax-result-table-cell-similarity-for-observation [projects]="similarProjects"
                                                          [publications]="similarPublications"
                                                          (onTabChanged)="onTabChanged($event)">
        </asax-result-table-cell-similarity-for-observation>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="row?.code">
    <ng-container *ngIf="!isLoading; else loading">
      <asax-result-table-cell-similarity-text
        [similarProjects]="similarProjects"
        [tabId]="'projects'"
      ></asax-result-table-cell-similarity-text>
      <asax-result-table-cell-similarity-for-project [projects]="similarProjects">
      </asax-result-table-cell-similarity-for-project>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="row?.bibCode">
    <ng-container *ngIf="!isLoading; else loading">
      <asax-result-table-cell-similarity-text
        [similarPublications]="similarPublications"
        [tabId]="'publications'"
      ></asax-result-table-cell-similarity-text>
      <asax-result-table-cell-similarity-for-publication [publications]="similarPublications">>
      </asax-result-table-cell-similarity-for-publication>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #loading>
  <div class="d-flex justify-content-center">
    <div class="spinner-border spinner-border-sm" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</ng-template>
